import * as React from "react";
import ProductReviewSlider, {
    ProductReviewSliderProps
} from "~/components/product-review-slider/product-review-slider";

export interface ProductReviewSliderViewProps {
    contextModel: ProductReviewSliderProps;
}

class ProductReviewSliderView extends React.PureComponent<ProductReviewSliderViewProps> {
    public render() {
        return <ProductReviewSlider {...this.props.contextModel} />;
    }
}

export default ProductReviewSliderView;
